module.exports = __webpack_public_path__ + "media/butterfly_romp.546b2537.webm";